/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização do componente Wrap
 */

export const Wrap = styled.div`
    font-size: 8px;
    .coordinates{
        display: flex;        
    }
    .coordinates1{
        position: relative;        
        left: -3%;
    }
    .coordinates2{
        position: relative;        
        left: 4.5%;
    }
    .coordinates3{
        position: relative;        
        left: 13%;
    }
    .coordinates4{
        position: relative;        
        left: 21.5%;
    }
    .coordinates5{
        position: relative;        
        left: 29.5%;
    }
    .coordinates6{
        position: relative;        
        left: 37.5%;
    }
    .coordinates7{
        position: relative;        
        left: 46%;
    }
    .coordinates8{
        position: relative;        
        left: 52.8%;
    }
`;